import { useContext, useEffect, useState, useTransition } from "react";

import { DropdownSourceContext } from "@ryde/redux";
import { IFormAttributes, IRouteSchedule } from "@ryde/shared";

import { IExpandedRouteSchedule } from "./course-schedule-cell.models";
import { expandRouteSchedules } from "./course-schedule-cell.utils";

export const useCourseScheduleCell = (
  value: IRouteSchedule[] | undefined,
  formAttributes?: IFormAttributes | null,
): IExpandedRouteSchedule[] => {
  const { getDropdownItems } = useContext(DropdownSourceContext);
  const [displayValues, setDisplayValues] = useState<IExpandedRouteSchedule[]>(
    [],
  );
  const [, startTransition] = useTransition();

  useEffect(() => {
    const getItems = async (): Promise<void> => {
      if (!formAttributes?.dropItemsSource || !value?.length) {
        setDisplayValues([]);
        return;
      }

      const dropdownItems = await getDropdownItems?.(
        formAttributes.dropItemsSource,
      );

      if (!dropdownItems?.length) {
        setDisplayValues([]);
        return;
      }

      setDisplayValues(
        expandRouteSchedules({ schedules: value, dropdownItems }),
      );
    };

    startTransition(() => {
      getItems();
    });
  }, [value, formAttributes?.dropItemsSource, getDropdownItems]);

  return displayValues;
};
